module.exports = __webpack_public_path__ + "static/img/7.e97179e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/7.png
// module id = fT4z
// module chunks = 1 3